import React, { useState } from 'react';
import { auth } from '../utils/firebase-config';

const TWOFA_URL = 'https://europe-west1-dbos-core-prod.cloudfunctions.net/twofa';

export default function TwoFactorVerify({ gido, onSuccess, onCancel }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const idToken = await auth.currentUser.getIdToken();
      const res = await fetch(TWOFA_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
        body: JSON.stringify({ action: 'verify', code }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Verification failed');
      onSuccess();
    } catch (err) {
      console.error('2FA verification error:', err);
      setError(err.message || 'Invalid code');
      setCode('');
      setLoading(false);
    }
  };

  return (
    <div className="twofa-verify-container">
      <div className="twofa-card">
        <h2>🔐 Two-Factor Authentication</h2>
        <p className="twofa-subtitle">
          Enter the 6-digit code from Google Authenticator
        </p>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleVerify} className="verification-form">
          <div className="input-group">
            <label htmlFor="code">Authentication Code</label>
            <input
              id="code"
              type="text"
              inputMode="numeric"
              pattern="[0-9]{6}"
              maxLength="6"
              placeholder="000000"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
              required
              disabled={loading}
              autoFocus
              className="code-input"
            />
          </div>
          <button type="submit" disabled={loading || code.length !== 6} className="verify-button">
            {loading ? 'Verifying...' : 'Verify'}
          </button>
          <button type="button" onClick={onCancel} className="cancel-button" disabled={loading}>
            Cancel
          </button>
        </form>
        <div className="twofa-help">
          <p>Lost access to your authenticator?<br/>
          Contact <a href="mailto:admin@dbos.world">admin@dbos.world</a></p>
        </div>
      </div>
    </div>
  );
}